export default "__VITE_ASSET__D_bmSfO9__"